import { environment as defaultEnvironment } from './environment.defaults';

export const environment = {
  ...defaultEnvironment,

  apiUrl: '',
  log: true
};
